<p-toast sticky="true"></p-toast>

<section class="toggle-form" [ngClass]="{ active: isTrainingPlanSliderOpen }">
  <div class="formwrap">
    <div class="Header">
      <h2>
        <b>Add Training Requirement(s)</b>
      </h2>
      <div>
        <p-button
        appPreventDoubleClick
          styleClass="p-button-text"
          id="employeeTrainingPlanSliderCloseButton"
          type="button"
          label="Close"
          (debounceClick)="closeSlider()"
        ></p-button>
      </div>
    </div>
    <div class="general-container content">
      <p-tabView [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
        <p-tabPanel header="Training Item Group">
          <div class="content">
            <app-employee-training-plan-training-item-group-details
              [userPUID]="userPUID"
              [userScopes]="userScopes"
            >
            </app-employee-training-plan-training-item-group-details>
          </div>
        </p-tabPanel>
        <p-tabPanel
          header="Document"
          [rightIcon]="errorIconClassForDocumentTab"
        >
          <div class="content">
            <app-employee-training-plan-document-details
              [userScopes]="userScopes"
              [userPUID]="userPUID"
              (activateTabIndex)="openCurrentTab($event)"
            >
            </app-employee-training-plan-document-details>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Course" [rightIcon]="errorIconClassForCourseTab">
          <app-employee-training-plan-course-details
            [userScopes]="userScopes"
            [userPUID]="userPUID"
            (activateTabIndex)="openCurrentTab($event)"
          >
          </app-employee-training-plan-course-details>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</section>
